export default __webpack_public_path__ + "static/media/green-bagel2.05789dbf.svg";